"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ErrorMessage = void 0;

var React = _interopRequireWildcard(require("react"));

var _copyText = _interopRequireDefault(require("../errors/copyText"));

var _Message = _interopRequireDefault(require("../semantic/react/Message"));

require('../semantic/css/icon.css');

require('../semantic/css/message.css');

var ErrorMessage = function ErrorMessage(_ref) {
  var type = _ref.type,
      content = _ref.content,
      header = _ref.header,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? 'warning sign' : _ref$icon;
  return React.createElement(_Message.default, {
    content: content || _copyText.default["".concat(type, "_message")],
    header: header || _copyText.default["".concat(type, "_title")],
    icon: icon || 'warning sign',
    error: true
  });
};

exports.ErrorMessage = ErrorMessage;
var _default = ErrorMessage;
exports.default = _default;